module.exports = __webpack_public_path__ + "img/seo_glive_item01.a8c7fa5.webp";